import reportQuestion from './reportQuestion';

let timestampIndex = 0;

/**
 * 使用jsonp来请求
 * @param  {String} url     请求地址
 * @param  {Object} options 扩展参数，参数内容如下
 *   @param {String} jsonpCallback 需要服务器端返回的回调函数名称
 *   @param {String} jsonp 需要服务器端返回的回调函数的参数名称，因为有些系统不一定是callback
 *   @param {Object} data 需要传给服务器的参数，
 *   注意：参数会进行encodeURIComponent编码
 *   @param {Number || Boolean} cache 只能是数字类型，如果是false，则不会拼接该参数
 *   @param {Number} timeout jsonp超时时间，默认为60000毫秒
 *   @param {Boolean} isReportQuestion 是否需要上报慢请求，默认为上报
 *
 */
export default function(
    url,
    {
        data = {},
        jsonp = 'callback',
        jsonpCallback = `f_${new Date().valueOf().toString(16)}${timestampIndex++}`, // eslint-disable-line
        cache = `${new Date().valueOf()}${timestampIndex++}`,
        timeout = 60000,
    } = {},
) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
            reject(new Error(`timeout|请求超时${timeout}`));
        }, timeout);

        // 对参数进行处理
        const params = [];

        // 只支持对象传入
        if (typeof data === 'object') {
            for (const key of Object.keys(data)) {
                params.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
            }
        } else {
            reject(new Error('typeError|data必须为一个对象'));

            return;
        }

        params.push(`${encodeURIComponent(jsonp)}=${encodeURIComponent(jsonpCallback)}`);

        if (cache) {
            params.push(`_=${cache}`);
        }

        // 回头要不要对这地址进行更多特殊处理？
        if (url.includes('?')) {
            url = `${url}&${params.join('&')}`;
        } else {
            url = `${url}?${params.join('&')}`;
        }

        const insertScript = document.createElement('script');

        insertScript.src = url;

        window[jsonpCallback] = (...arg) => {
            reportQuestion(url);

            resolve(...arg);

            // try {
            //     delete window[jsonpCallback];
            // } catch (e) {
            //     window[jsonpCallback] = undefined;
            // }
        };

        insertScript.onload = insertScript.onreadystatechange = function onreadystatechange() {
            if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
                clearTimeout(timer);
                insertScript.onload = insertScript.onreadystatechange = null;
                const head = document.getElementsByTagName('head')[0];

                if (head) {
                    head.removeChild(insertScript);
                }
            }
        };

        insertScript.onerror = function onerror() {
            clearTimeout(timer);
            reject(new Error('scriptLoaderror|脚本加载错误'));
        };

        const head = document.getElementsByTagName('head')[0];

        if (head) {
            head.appendChild(insertScript);
        }
    });
}
